import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { isMultipleCampusAdmin } from '../utils';

const styles = (theme) => ({
  profileInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderLeft: `1px solid ${theme.palette.primary.main}`,
    marginLeft: 70,
    paddingLeft: 40,
  },
  profileInfoHomePageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'absolute',
  },
  profileInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  title: {
    fontSize: '0.925rem',
    color: theme.palette.primary.main,
  },
  homePageTitle: {
    fontSize: '24px',
    lineHeight: '25px',
    color: theme.palette.primary.main,
  },
  description: {
    fontSize: '1.225rem',
    color: theme.palette.primary.main,
  },
  homePageDescription: {
    fontSize: '37px',
    lineHeight: '38px',
    color: theme.palette.primary.main,
  },
  // Demo: compact layout when rendered inside the avatar dropdown menu.
  menuContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '6px 16px 4px',
    minWidth: 200,
  },
  menuInfo: {
    marginBottom: 10,
  },
  menuTitle: {
    fontSize: '0.68rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: '#9aa6a8',
  },
  menuValue: {
    fontSize: '0.9rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
});

class UserInfoBanner extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.any.isRequired,
    profile: PropTypes.object,
    initSchools: PropTypes.func.isRequired,
    initTags: PropTypes.func.isRequired,
    schoolList: PropTypes.object,
    isHomePage: PropTypes.bool,
    tags: PropTypes.object,
    inMenu: PropTypes.bool,
  };

  state = {
    isTagsLoaded: false,
  };

  componentDidMount() {
    this.shouldInit();
  }

  componentDidUpdate() {
    this.shouldInit();
  }

  shouldInit() {
    const { profile, schoolList, tags, initSchools, initTags } = this.props;
    const didSchoolListLoad = Object.keys(schoolList).length;
    const { isTagsLoaded } = this.state;
    if (profile) {
      if (!didSchoolListLoad) {
        initSchools(profile);
      }
      if (!isTagsLoaded) {
        initTags(profile);
        this.setState({ isTagsLoaded: true });
      }
    }
  }

  // `rawDescription` skips startCase for values that are proper names (e.g. a user's
  // displayName): startCase would turn "CoPilot Support" into "Co Pilot Support".
  renderOneInfo = (title, description, marginRight = 70, rawDescription = false) => {
    const { classes, isHomePage, inMenu } = this.props;
    const value = rawDescription ? description : _.startCase(description);
    if (inMenu) {
      return (
        <div className={classes.menuInfo}>
          <div className={classes.menuTitle}>{_.startCase(title)}</div>
          <div className={classes.menuValue}>{value}</div>
        </div>
      );
    }
    return (
      <div className={classes.profileInfo} style={{ marginRight }}>
        <div className={isHomePage ? classes.homePageTitle : classes.title}>{_.startCase(title)}</div>
        <div className={isHomePage ? classes.homePageDescription : classes.description}>{value}</div>
      </div>
    );
  };

  render() {
    const { classes, profile, schoolList, isHomePage, tags, inMenu } = this.props;
    if (profile) {
      const isAuthMultipleCampusAdmin = isMultipleCampusAdmin(profile);
      const didSchoolListLoad = Object.keys(schoolList).length;

      const districtCampusTitle = profile.role === 'districtAdmin' ? 'District Name' : 'Campus Name';
      let districtCampusName =
        profile.role === 'districtAdmin'
          ? profile.districtNumber
          : `${isAuthMultipleCampusAdmin ? 'Multiple Campuses' : profile.campusNumber}`;

      if (didSchoolListLoad && !isAuthMultipleCampusAdmin) {
        districtCampusName =
          (profile.role === 'districtAdmin'
            ? schoolList[profile.districtNumber] && schoolList[profile.districtNumber].name
            : schoolList[profile.campusNumber] && schoolList[profile.campusNumber].name) || districtCampusName;
      }
      const marginInfo = isHomePage ? 100 : 70;
      return (
        <div
          className={
            inMenu
              ? classes.menuContainer
              : isHomePage
              ? classes.profileInfoHomePageContainer
              : classes.profileInfoContainer
          }
        >
          {this.renderOneInfo(profile.role, profile.displayName, marginInfo, true)}
          {this.renderOneInfo(districtCampusTitle, districtCampusName, marginInfo)}
          {this.renderOneInfo('Tier', profile.userType, 0)}
        </div>
      );
    }
    return null;
  }
}

export default withStyles(styles)(UserInfoBanner);
